<template>
    <b-container fluid>
        <b-row v-if="!roundsData">
            <b-col>
                <b-alert variant="info" show>Esperando información</b-alert>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col>
                <app-data-table
                    :fields="fields"
                    :items="roundsData.data"
                    :current-page="roundsData.current_page"
                    :last-page="roundsData.last_page"
                    :from="roundsData.from"
                    :to="roundsData.to"
                    :total="roundsData.total"
                    :per-page="roundsData.per_page"
                    :on-change-page="onChangePage"
                    @sort="onSort"
                >
                    <template slot="complete" slot-scope="{ item }">
                        {{ !!item.end_date && !item.incomplete ? 'Si' : 'No' }}
                    </template>

                    <template slot="actions" slot-scope="{ item }">
                        <b-btn
                            variant="primary"
                            size="sm"
                            @click="showCheckpoints(item)"
                            ><i class="fa fa-map-pin"></i
                        ></b-btn>
                    </template>
                </app-data-table>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    props: {
        roundsData: {
            type: Object,
        },
    },
    data: () => ({
        fields,
    }),
    methods: {
        onChangePage(page) {
            this.$emit('changePage', page)
        },
        showCheckpoints(roundInstance) {
            this.$emit('show-checkpoints', roundInstance)
        },
        loadCheckpoints(id) {
            const rr = { ...roundsRepository }
        },
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
    },
}

const fields = [
    {
        key: 'id',
        label: 'Instancia',
    },
    {
        key: 'round.client.name',
        label: 'Cliente',
        orderBy: 'clients.name',
    },
    {
        key: 'round.name',
        label: 'Ronda',
        orderBy: 'rounds.name',
    },
    {
        key: 'round.start_hour',
        label: 'Franja Inicio',
        orderBy: 'round_instances.start_hour',
    },
    {
        key: 'round.end_hour',
        label: 'Franja Fin',
        orderBy: 'round_instances.end_hour',
    },
    {
        key: 'round.duration',
        label: 'Duración',
        orderBy: 'rounds.duration',
    },
    {
        key: 'user.name',
        label: 'Vigilante',
        orderBy: 'users.name',
    },
    {
        key: 'start_date',
        label: 'Fecha de inicio',
        orderBy: 'round_instances.start_date',
    },
    {
        key: 'end_date',
        label: 'Fecha Fin',
        orderBy: 'round_instances.end_date',
    },
    {
        key: 'notes',
        label: 'Notas',
        sortable: false,
    },
    {
        key: 'complete',
        label: 'Completa',
        orderBy: 'round_instances.incomplete',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
</script>
